import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatPaginatorIntl } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HotkeyModule } from 'angular2-hotkeys';
import { TipoDocumentacaoController } from 'app/controllers/grl/tipo-documentacao.controller';
import { ParadaController } from 'app/controllers/mob/parada.controller';
import { TaxiParadaController } from 'app/controllers/mob/taxi-parada.controller';
import { TaxiParadaService } from 'app/services/mob/taxi-parada.service';
import { NgxMaskModule } from 'ngx-mask';
import { DialogFactory } from 'sol-tools-ts/dist';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CategoriaVeiculoController } from './controllers/fta/categoria-veiculo.controller';
import { CorVeiculoController } from './controllers/fta/cor-veiculo.controller';
import { CorController } from './controllers/fta/cor.controller';
import { EspecieVeiculoController } from './controllers/fta/especieveiculo.controller';
import { MarcaModeloController } from './controllers/fta/marca-modelo.controller';
import { TipoVeiculoController } from './controllers/fta/tipo-veiculo.controller';
import { VeiculoController } from './controllers/fta/veiculo.controller';
import { CidadeController } from './controllers/grl/cidade.controller';
import { DoencaController } from './controllers/grl/doenca.controller';
import { EquipamentoController } from './controllers/grl/equipamento.controller';
import { EstadoController } from './controllers/grl/estado.controller';
import { FeriadoController } from './controllers/grl/feriado.controller';
import { LogradouroController } from './controllers/grl/logradouro.controller';
import { MedicoController } from './controllers/grl/medico.controller';
import { ParametroController } from './controllers/grl/parametro.controller';
import { PessoaFisicaJuridicaController } from './controllers/grl/pessoa-fisica-juridica.controller';
import { PessoaFisicaController } from './controllers/grl/pessoa-fisica.controller';
import { PessoaJuridicaController } from './controllers/grl/pessoa-juridica.controller';
import { PessoaController } from './controllers/grl/pessoa.controller';
import { TipoLogradouroController } from './controllers/grl/tipo-logradouro.controller';
import { TipoOcorrenciaController } from './controllers/grl/tipo-ocorrencia.controller';
import { TiposArquivosController } from './controllers/grl/tipos-arquivos.controller';
import { VinculoController } from './controllers/grl/vinculo.controller';
import { AfericaoCatracaController } from './controllers/mob/afericao-catraca.controller';
import { AgenteController } from './controllers/mob/agente.controller';
import { AitTransporteController } from './controllers/mob/ait-transporte.controller';
import { CartaoController } from './controllers/mob/cartao.controller';
import { ConcessaoArquivoController } from './controllers/mob/concessao-arquivo.controller';
import { ConcessaoColetivoUrbanoController } from './controllers/mob/concessao-coletivo-urbano.controller';
import { ConcessaoVeiculoController } from './controllers/mob/concessao-veiculo.controller';
import { ConcessaoController } from './controllers/mob/concessao.controller';
import { ConcessionarioPessoaController } from './controllers/mob/concessionario-pessoa.controller';
import { GratuidadeSolicitacoesController } from './controllers/mob/gratuidade-solicitacoes.controller';
import { GrupoParadaController } from './controllers/mob/grupo-parada.controller';
import { HorarioAfericaoController } from './controllers/mob/horario-afericao.controller';
import { HorarioController } from './controllers/mob/horario.controller';
import { ImpedimentoAfericaoController } from './controllers/mob/impedimento-afericao.controller';
import { InfracaoMotivoController } from './controllers/mob/infracao-motivo.controller';
import { InfracaoTransporteController } from './controllers/mob/infracao-transporte.controller';
import { InfracaoController } from './controllers/mob/infracao.controller';
import { LacreController } from './controllers/mob/lacre.controller';
import { LinhaRotaController } from './controllers/mob/linha-rota.controller';
import { LinhaTrechoController } from './controllers/mob/linha-trecho.controller';
import { LinhaController } from './controllers/mob/linha.controller';
import { MotivoEncerramentoController } from './controllers/mob/motivo-encerramento-ait.controller';
import { MotivoImpedimentoController } from './controllers/mob/motivo-impedimento.controller';
import { PericiaController } from './controllers/mob/pericia.controller';
import { PlanoVistoriaController } from './controllers/mob/plano-vistoria.controller';
import { RecursoController } from './controllers/mob/recurso.controller';
import { RelatorioVistoriaController } from './controllers/mob/relatorio-vistoria.controller';
import { TabelaHorarioController } from './controllers/mob/tabela-horario.controller';
import { TalonarioAitController } from './controllers/mob/talonario-ait.controller';
import { TaxiPontoController } from './controllers/mob/taxi-ponto.controller';
import { TerminalController } from './controllers/mob/terminal.controller';
import { VeiculoEquipamentoController } from './controllers/mob/veiculo-equipamento.controller';
import { VistoriaController } from './controllers/mob/vistoria.controller';
import { SituacaoDocumentoController } from './controllers/ptc/situacao-documento.controller';
import { UtilsController } from './controllers/utils/utils.controller';
import { CategoriaVeiculoService } from './services/fta/categoria-veiculo.service';
import { CorVeiculoService } from './services/fta/cor-veiculo.service';
import { CorService } from './services/fta/cor.service';
import { EspecieVeiculoService } from './services/fta/especieveiculo.service';
import { MarcaModeloService } from './services/fta/marca-modelo.service';
import { TipoVeiculoService } from './services/fta/tipo-veiculo.service';
import { VeiculoService } from './services/fta/veiculo.service';
import { CidadeService } from './services/grl/cidade.service';
import { DoencaService } from './services/grl/doenca.service';
import { EquipamentoService } from './services/grl/equipamento.service';
import { EstadoService } from './services/grl/estado.service';
import { FeriadoService } from './services/grl/feriado.service';
import { LogradouroServices } from './services/grl/logradouro.service';
import { MedicoService } from './services/grl/medico.service';
import { ParametroService } from './services/grl/parametro.services';
import { PessoaFisicaJuridicaService } from './services/grl/pessoa-fisica-juridica.service';
import { PessoaFisicaService } from './services/grl/pessoa-fisica.service';
import { PessoaJuridicaService } from './services/grl/pessoa-juridica.service';
import { PessoaService } from './services/grl/pessoa.service';
import { TipoDocumentacaoService } from './services/grl/tipo-documentacao.service';
import { TipoLogradouroService } from './services/grl/tipo-logradouro.service';
import { TipoOcorrenciaService } from './services/grl/tipo-ocorrencia.service';
import { TiposArquivosServices } from './services/grl/tipos-arquivos.service';
import { VinculoService } from './services/grl/vinculo.service';
import { LoaderService } from './services/loader.service';
import { AfericaoCatracaService } from './services/mob/afericao-catraca.service';
import { AgenteService } from './services/mob/agente.service';
import { AitTransporteService } from './services/mob/ait-transporte.service';
import { CartaoService } from './services/mob/cartao.service';
import { ConcessaoArquivoService } from './services/mob/concessao-arquivo.service';
import { ConcessaoColetivoUrbanoService } from './services/mob/concessao-coletivo-urbano.service';
import { ConcessaoVeiculoService } from './services/mob/concessao-veiculo.service';
import { ConcessaoService } from './services/mob/concessao.service';
import { ConcessionarioPessoaService } from './services/mob/concessionario-pessoa.service';
import { GratuidadeSolicitacoesService } from './services/mob/gratuidade-solicitacoes.services';
import { GrupoParadaService } from './services/mob/grupo-parada.service';
import { HorarioAfericaoService } from './services/mob/horario-afericao.service';
import { HorarioService } from './services/mob/horario.service';
import { ImpedimentoAfericaoService } from './services/mob/impedimento-afericao.service';
import { InfracaoMotivoService } from './services/mob/infracao-motivo.service';
import { InfracaoTransporteService } from './services/mob/infracao-transporte.service';
import { InfracaoService } from './services/mob/infracao.service';
import { LacreService } from './services/mob/lacre.services';
import { LinhaRotaService } from './services/mob/linha-rota.services';
import { LinhaTrechoService } from './services/mob/linha-trecho.service';
import { LinhaService } from './services/mob/linha.services';
import { MotivoEncerramentoServices } from './services/mob/motivo-encerramento.service';
import { MotivoImpedimentoService } from './services/mob/motivo-impedimento.service';
import { ParadaService } from './services/mob/parada.service';
import { PericiaService } from './services/mob/pericia.service';
import { PlanoVistoriaService } from './services/mob/plano-vistoria.services';
import { RecursoService } from './services/mob/recurso.service';
import { RelatorioVistoriaService } from './services/mob/relatorio-vistoria.service';
import { TabelaHorarioService } from './services/mob/tabela-horario.service';
import { TalonarioAitService } from './services/mob/talonario-ait.service';
import { TaxiNumeroOrdemServices } from './services/mob/taxi-numero-ordem.service';
import { TaxiPontoService } from './services/mob/taxi-ponto.service';
import { TaxiPontosServices } from './services/mob/taxi-pontos.services';
import { TerminalService } from './services/mob/terminal.service';
import { VeiculoEquipamentoService } from './services/mob/veiculo-equipamento.service';
import { VistoriaService } from './services/mob/vistoria.services';
import { SituacaoDocumentoServices } from './services/ptc/situacao-documento.services';
import { UtilsService } from './services/utils/utils.service';
import { SharedModule } from './shared/shared.module';
import { MomentDateAdapter, MOMENT_DATE_FORMATS } from './tools/date-adapter';
import { LoaderComponent } from './view/loader/loader.component';
import { NotFoundComponent } from './view/not-found/not-found.component';
import { GrupoParametroController } from './controllers/grl/grupo-parametro.controller';
import { GrupoParametroService } from './services/grl/grupo-parametro.service';
import { ParametroGrupoController } from './controllers/grl/parametro-grupo.controller';
import { TraducaoPaginator } from './tools/paginator-intl';
import { OrgaoService } from './services/mob/orgao.service';
import { OrgaoController } from './controllers/mob/orgao.controller';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    LoaderComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    HotkeyModule.forRoot(),
    NgxMaskModule.forRoot()
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MatPaginatorIntl, useClass: TraducaoPaginator },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
    LoaderService,
    CidadeService,
    CidadeController,
    EstadoService,
    EstadoController,
    MarcaModeloService,
    MarcaModeloController,
    TalonarioAitController,
    TalonarioAitService,
    PessoaService,
    PessoaController,
    TipoLogradouroController,
    TipoLogradouroService,
    TipoOcorrenciaController,
    TipoOcorrenciaService,
    VeiculoService,
    VeiculoController,
    LacreController,
    LacreService,
    ConcessaoService,
    ConcessaoController,
    ConcessaoColetivoUrbanoController,
    ConcessaoColetivoUrbanoService,
    VistoriaController,
    VistoriaService,
    PlanoVistoriaService,
    PlanoVistoriaController,
    TipoVeiculoService,
    TipoVeiculoController,
    CorService,
    CorController,
    CategoriaVeiculoService,
    CategoriaVeiculoController,
    VistoriaController,
    VistoriaService,
    PlanoVistoriaService,
    PlanoVistoriaController,
    DialogFactory,
    ConcessaoVeiculoController,
    ConcessaoVeiculoService,
    ConcessaoArquivoController,
    ConcessaoArquivoService,
    ConcessionarioPessoaService,
    ConcessionarioPessoaController,
    VeiculoEquipamentoController,
    VeiculoEquipamentoService,
    UtilsController,
    UtilsService,
    ParametroController,
    ParametroService,
    AitTransporteService,
    AitTransporteController,
    InfracaoService,
    InfracaoController,
    InfracaoTransporteService,
    InfracaoTransporteController,
    InfracaoMotivoService,
    InfracaoMotivoController,
    LinhaService,
    LinhaController,
    ParadaService,
    ParadaController,
    GrupoParadaService,
    GrupoParadaController,
    VinculoService,
    VinculoController,
    TiposArquivosController,
    TiposArquivosServices,
    MotivoEncerramentoController,
    MotivoEncerramentoServices,
    TabelaHorarioController,
    TabelaHorarioService, 
    LinhaRotaController,
    LinhaRotaService,
    TerminalController,
    TerminalService,
    HorarioAfericaoController,
    HorarioAfericaoService,
    AfericaoCatracaController,
    AfericaoCatracaService,
    AgenteController,
    AgenteService,
    MotivoImpedimentoController,
    MotivoImpedimentoService,
    ImpedimentoAfericaoController,
    ImpedimentoAfericaoService,
    EspecieVeiculoController,
    EspecieVeiculoService, 
    TaxiPontosServices,
    TaxiNumeroOrdemServices,
    LogradouroController,
    LogradouroServices,
    OrgaoService,
    OrgaoController,
    CartaoService,
    CartaoController,
    GratuidadeSolicitacoesController,
    GratuidadeSolicitacoesService,
    SituacaoDocumentoController,
    SituacaoDocumentoServices,
    PessoaFisicaController,
    PessoaJuridicaController,
    PessoaFisicaJuridicaController,
    PessoaFisicaService,
    PessoaJuridicaService,
    PessoaFisicaJuridicaService,
    DoencaService,
    DoencaController,
    MedicoService,
    MedicoController,
    ParadaService,
    ParadaController,
    GrupoParadaService,
    GrupoParadaController,
    ParadaService,
    ParadaController,
    GrupoParadaService,
    GrupoParadaController,
    LinhaRotaController,
    LinhaRotaService,
    HorarioService,
    HorarioController,
    LinhaTrechoService,
    LinhaTrechoController,
    RelatorioVistoriaService,
    RelatorioVistoriaController,
    RecursoController,
    RecursoService,
    PericiaService,
    PericiaController,
    TaxiPontoController,
    TaxiPontoService,
    TaxiParadaController,
    TaxiParadaService,
    EquipamentoController,
    EquipamentoService,
    TipoDocumentacaoController,
    TipoDocumentacaoService,
    CorVeiculoController,
    CorVeiculoService,
    FeriadoController, 
    FeriadoService,
    GrupoParametroController,
    GrupoParametroService,
    ParametroGrupoController
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
